import { all, takeLatest } from 'redux-saga/effects';
import * as onboardingActions from '../actions';
import getOnboardingState from './worker.getOnboardingState';

function* onboardingSaga() {
  yield all([takeLatest(onboardingActions.requestGetOnboardingState.type, getOnboardingState)]);
}

export default onboardingSaga;
